import React, { createContext, useContext, ReactNode } from "react";
import { useMainChat } from "@root/hooks/useMainChat";

const defaultState: any = {};

const KPSChatContext = createContext<any>(defaultState);

interface KPSChatProviderProps {
  children: ReactNode;
}

export const KPSChatProvider: React.FC<KPSChatProviderProps> = ({
  children,
}) => {
  const chat = useMainChat();
  return (
    <KPSChatContext.Provider value={chat}>{children}</KPSChatContext.Provider>
  );
};

export const useMainChatContext = () => {
  return useContext(KPSChatContext);
};